
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cbtdY", function(module, exports) {

$parcel$export(module.exports, "EPCheck", () => $ec46d5b8549a93e3$export$662f3e7de71f1a7);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $1Iui1 = parcelRequire("1Iui1");

var $79xbN = parcelRequire("79xbN");

var $cPEpP = parcelRequire("cPEpP");

var $8zULB = parcelRequire("8zULB");
const $ec46d5b8549a93e3$export$662f3e7de71f1a7 = ({ onComplete: onComplete, children: children })=>{
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cross-flow-defer-edition-communication');
    const cohort = expConfig.get((0, $1Iui1.COHORT), (0, $1Iui1.NOT_ENROLLED));
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    const [hasMessageStarted, setHasMessageStarted] = (0, $eUqFw.useState)(false);
    const [hasCheckedEpMessage, setHasCheckedEpMessage] = (0, $eUqFw.useState)(false);
    const { start: checkEPMessage } = (0, $8zULB.useCoordinationClient)(projectType);
    const isEnrolled = cohort === (0, $1Iui1.VARIATION);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnrolled || hasCheckedEpMessage || projectType === undefined) return;
        (async ()=>{
            setHasCheckedEpMessage(true);
            const hasStarted = await checkEPMessage();
            setHasMessageStarted(hasStarted);
            hasStarted && onComplete();
        })();
    }, [
        checkEPMessage,
        hasCheckedEpMessage,
        isEnrolled,
        onComplete,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasMessageStarted && children);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);
$parcel$export(module.exports, "VAR1", () => $1524157debf2fd00$export$6486974e39493fa6);
$parcel$export(module.exports, "VAR2", () => $1524157debf2fd00$export$7d994996134ad562);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("8zULB", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $22610640d04a1bc1$export$ddc368dc94a41e62);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $5ge6s = parcelRequire("5ge6s");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $h1a1F = parcelRequire("h1a1F");

var $ihQ7S = parcelRequire("ihQ7S");
const $22610640d04a1bc1$export$ddc368dc94a41e62 = (projectType)=>{
    const epMessageId = (0, $h1a1F.useDeferEpMessageKey)(projectType);
    const { checkJpdUserProperties: checkJpdUserProperties } = (0, $ihQ7S.useJpdModalCanShow)(projectType);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const coordinationClient = (0, $eUqFw.useMemo)(()=>new (0, $5ge6s.CoordinationClient)(cloudId, '/gateway/api', false, orgId), [
        cloudId,
        orgId
    ]);
    const start = (0, $eUqFw.useCallback)(async ()=>{
        if (!epMessageId) return false;
        // For JPD we need to check a user property that tells if a modal that is
        // not using EP has been dismissed
        if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) {
            const jpdModalWasShown = await checkJpdUserProperties();
            if (!jpdModalWasShown) return false;
        }
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        projectType,
        coordinationClient,
        checkJpdUserProperties
    ]);
    const stop = (0, $eUqFw.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        start: start,
        stop: stop
    };
};

});
parcelRegister("5ge6s", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $67d1cec28351d2e7$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $67d1cec28351d2e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hRleJ = parcelRequire("hRleJ");

var $hpAuL = parcelRequire("hpAuL");
var $8Voen = parcelRequire("8Voen");

var $e91YZ = parcelRequire("e91YZ");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $jD3pk = parcelRequire("jD3pk");

var $38OPi = parcelRequire("38OPi");
const $67d1cec28351d2e7$var$isSyntheticTenant = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';
const $67d1cec28351d2e7$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
const $67d1cec28351d2e7$var$getEnvironmentType = (env)=>{
    if (env === 'prod') return (0, $hRleJ.envType).PROD;
    if (env === 'staging') return (0, $hRleJ.envType).STAGING;
    return (0, $hRleJ.envType).DEV;
};
class $67d1cec28351d2e7$export$580a2294c917898c extends (0, $8Voen.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = ''){
        const coordinationOptions = {
            envType: $67d1cec28351d2e7$var$getEnvironmentType($67d1cec28351d2e7$var$environment),
            enableChoreographer: (0, $1ybV0.ff)('post-office_enable_jira_choreographer')
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $67d1cec28351d2e7$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $1ybV0.ff)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) await super.stop(messageId);
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId);
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId);
    }
}
function $67d1cec28351d2e7$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const client = new $67d1cec28351d2e7$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hpAuL.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children);
}

});

parcelRegister("h1a1F", function(module, exports) {

$parcel$export(module.exports, "useDeferEpMessageKey", () => $10dfb904307aea39$export$46bdb0804933a5fd);

var $7ZZxN = parcelRequire("7ZZxN");

var $3e9vj = parcelRequire("3e9vj");

const $10dfb904307aea39$export$46bdb0804933a5fd = (projectType)=>{
    const environment = (0, $3e9vj.useEnvironment)();
    const isProdEnv = environment === 'prod';
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$f36bed87d45a98de) : (0, $9a060b7ebf877081$export$a0f8b0f73985911a);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$475f4ac16b63ff71) : (0, $9a060b7ebf877081$export$3fc71bcf4d7deeea);
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$58003a8be3bebb14) : (0, $9a060b7ebf877081$export$4b374f476a475bef);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return isProdEnv ? (0, $9a060b7ebf877081$export$b302977ba64b0fa) : (0, $9a060b7ebf877081$export$bfaa609ebcf522b6);
        default:
            return undefined;
    }
};

});
parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

const $9a060b7ebf877081$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $9a060b7ebf877081$export$d57b6b390e78d90f = 'transmuters-growth';
const $9a060b7ebf877081$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $9a060b7ebf877081$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';


parcelRegister("ihQ7S", function(module, exports) {

$parcel$export(module.exports, "useJpdModalCanShow", () => $d0ab2c80c06c4667$export$26df648c1e84f4b0);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $48bs8 = parcelRequire("48bs8");

var $51tNX = parcelRequire("51tNX");

var $dxcfv = parcelRequire("dxcfv");
const $d0ab2c80c06c4667$export$26df648c1e84f4b0 = (projectType)=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const checkJpdUserProperties = (0, $eUqFw.useCallback)(async ()=>{
        try {
            if (!accountId || projectType !== (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return false;
            const userProperties = await (0, $48bs8.getUserProperty)('', accountId, (0, $51tNX.ONBOARDING_USER_PROPERTY));
            return userProperties.videoTutorial.isShown && userProperties.videoTutorial.isClosed;
        } catch (e) {
            return false;
        }
    }, [
        accountId,
        projectType
    ]);
    return {
        checkJpdUserProperties: checkJpdUserProperties
    };
};

});
parcelRegister("51tNX", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_USER_PROPERTY", () => $24dc8fde49456696$export$8847e25a41562496);
$parcel$export(module.exports, "SHOULD_SEE_ONBOARDING_USER_PROPERTY", () => $24dc8fde49456696$export$ac1aea911a3e465e);
$parcel$export(module.exports, "PRODUCT_START_TIMESTAMP", () => $24dc8fde49456696$export$810ba1749ac4ea65);
$parcel$export(module.exports, "initialRemoteState", () => $24dc8fde49456696$export$26a7cc4e9cf548ae);

var $7auAg = parcelRequire("7auAg");

var $5XALQ = parcelRequire("5XALQ");
const $24dc8fde49456696$export$8847e25a41562496 = 'polaris.onboarding';
const $24dc8fde49456696$export$ac1aea911a3e465e = 'polaris.should-see-onboarding-spotlights';
const $24dc8fde49456696$export$810ba1749ac4ea65 = 'polaris.product-start-timestamp';
const $24dc8fde49456696$export$26a7cc4e9cf548ae = {
    spotlights: {
        [(0, $5XALQ.SpotlightTypes).CREATE_IDEA]: false,
        [(0, $5XALQ.SpotlightTypes).CREATE_INSIGHT]: false,
        [(0, $5XALQ.SpotlightTypes).CREATE_DELIVERY_TICKET]: false,
        [(0, $5XALQ.SpotlightTypes).JOIN_COMMUNITY]: false
    },
    videoTutorial: {
        isShown: false,
        isClosed: false,
        mode: (0, $7auAg.ModalMode).DEFAULT
    },
    isVideoButtonInHelpPanelClicked: false
};

});
parcelRegister("7auAg", function(module, exports) {

$parcel$export(module.exports, "ModalMode", () => $1a97118f5f9de7ca$export$5d6770e5bdfdce3d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $1a97118f5f9de7ca$export$5d6770e5bdfdce3d;
(function(ModalMode) {
    ModalMode["DOCKED"] = "docked";
    ModalMode["DEFAULT"] = "default";
    ModalMode["EXPANDED"] = "expanded";
})($1a97118f5f9de7ca$export$5d6770e5bdfdce3d || ($1a97118f5f9de7ca$export$5d6770e5bdfdce3d = {}));

});

parcelRegister("5XALQ", function(module, exports) {

$parcel$export(module.exports, "SpotlightTypes", () => $7eeb8c86cd415c78$export$f132aec8aabdab25);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7eeb8c86cd415c78$export$f132aec8aabdab25;
(function(SpotlightTypes) {
    SpotlightTypes["CREATE_IDEA"] = "CREATE_IDEA_CLOSED";
    SpotlightTypes["CREATE_INSIGHT"] = "CREATE_INSIGHT_CLOSED";
    SpotlightTypes["CREATE_DELIVERY_TICKET"] = "CREATE_DELIVERY_TICKET_CLOSED";
    SpotlightTypes["JOIN_COMMUNITY"] = "JOIN_COMMUNITY_CLOSED";
})($7eeb8c86cd415c78$export$f132aec8aabdab25 || ($7eeb8c86cd415c78$export$f132aec8aabdab25 = {}));

});






//# sourceMappingURL=async-jira-defer-edition-ep-check.4a0771f6.js.map
